/**
 * AccountInfoType
 *
 * Identifies the row tapped inside the AccountInfoSheet. The string values are
 * referenced from `AccountInfoContent`'s switch statement and from the static
 * item list in `useAccountInfoItems`, so they must remain stable.
 *
 * Flutter source: lib/presentation/bottom_sheet/account_info_bottom_sheet.dart
 * (the `_accountItems` list at lines 33-82, plus the admin `insert(0, ...)` at
 * lines 91-100). The web port omits the Settings entry (Settings lives on
 * `UserActionsSheet` on web). The Admin entry is prepended as the first item,
 * matching Flutter's `_accountItems.insert(0, ...)`, and is gated on the
 * current user being an admin / super-admin.
 */

export enum AccountInfoType {
  ADMIN = 'admin',
  WALLET = 'wallet',
  UNLOCKED_VIDEOS = 'unlockedVideos',
  SUBSCRIPTIONS = 'subscriptions',
  SUBSCRIBERS = 'subscribers',
  LIKES = 'likes',
  WATCH_LATER = 'watchLater',
  FAVOURITE_PEOPLE = 'favouritePeople',
}
